import React from "react";

const formatDate = (value) => new Date(value).toLocaleString();

export default function CampaignQuestionnaireResponseReceipt({
  receipt,
  sessionExpiresAt,
}) {
  const reviewed = receipt.state === "reviewed";
  const multiAnswer = receipt.schemaVersion
    === "campaign_uat_questionnaire_response_receipt.v2";

  return (
    <section
      aria-labelledby="campaign-response-receipt-title"
      className="mt-5 rounded-xl border border-emerald-200 bg-emerald-50 p-5"
      data-testid="campaign-questionnaire-response-receipt"
    >
      <h2
        className="text-lg font-semibold text-emerald-950"
        id="campaign-response-receipt-title"
      >
        {reviewed
          ? "Synthetic response reviewed"
          : "Synthetic response submitted"}
      </h2>
      <p className="mt-2 text-sm text-emerald-950">
        The saved {multiAnswer ? "answers were" : "answer was"} cleared from this browser view. This durable,
        answer-free receipt can be restored while the verified session remains
        active.
      </p>
      <dl className="mt-4 grid gap-3 sm:grid-cols-2">
        <div className="rounded-lg border border-emerald-200 bg-white p-3">
          <dt className="text-xs font-semibold uppercase tracking-wide text-slate-500">
            Response state
          </dt>
          <dd className="mt-1 text-sm font-medium capitalize text-slate-900">
            {receipt.state}
          </dd>
        </div>
        <div className="rounded-lg border border-emerald-200 bg-white p-3">
          <dt className="text-xs font-semibold uppercase tracking-wide text-slate-500">
            Answers received
          </dt>
          <dd className="mt-1 text-sm font-medium text-slate-900">
            {receipt.answerCount}
          </dd>
        </div>
        <div className="rounded-lg border border-emerald-200 bg-white p-3">
          <dt className="text-xs font-semibold uppercase tracking-wide text-slate-500">
            Submitted
          </dt>
          <dd className="mt-1 text-sm font-medium text-slate-900">
            {formatDate(receipt.submittedAt)}
          </dd>
        </div>
        <div className="rounded-lg border border-emerald-200 bg-white p-3">
          <dt className="text-xs font-semibold uppercase tracking-wide text-slate-500">
            Advisor review
          </dt>
          <dd className="mt-1 text-sm font-medium text-slate-900">
            {reviewed ? formatDate(receipt.reviewedAt) : "Pending"}
          </dd>
        </div>
      </dl>
      <p className="mt-4 text-xs text-emerald-900">
        Receipt revision {receipt.responseRevision}. Session expires {formatDate(sessionExpiresAt)}.
      </p>
      <div
        className="mt-4 rounded-lg border border-emerald-200 bg-white p-3 text-xs text-emerald-950"
        role="status"
      >
        Safety verified: providers, email, legacy submission writes,
        engagement activity, booking, and CRM changes remain disabled.
      </div>
    </section>
  );
}
